import React, { useEffect, useRef } from 'react';

import Maintenance from '@/pages/Maintenance';

import Routers from './Router';

const App = () => {
  const shouldLog = useRef(true);

  useEffect(() => {
    // if (shouldLog.current) {
    //   shouldLog.current = false;
    //   if (
    //     window.location.origin === 'https://staging.dante-ai.com'
    //     //  ||
    //     // window.location.origin === 'https://d24dh0i3qzotw3.cloudfront.net'
    //   ) {
    //     const hardcodedPassword = 'Dante@111';
    //     const passwordInput = prompt('Enter the password to access this app:');

    //     if (!passwordInput) {
    //       alert('Incorrect password. You are not authorized to use this app.');
    //       window.location.href = 'https://www.google.com/';
    //     } else if (passwordInput) {
    //       if (passwordInput !== hardcodedPassword) {
    //         alert('Incorrect password. You are not authorized to use this app.');
    //         window.location.href = 'https://www.google.com/';
    //       }
    //     } else {
    //       window.location.href = 'https://www.google.com/';
    //     }
    //   }
    // }

    //Cleans up google analytics parameters from the url bar
    const url = window.location.href;
    const urlParts = url.split('?');
    const params = new URLSearchParams(urlParts[1]);
    params.delete('_gl');
    params.delete('deviceId');
    let newUrl = urlParts[0] + '?' + params.toString();
    const length = newUrl.length;
    if (newUrl.charAt(length - 1) === '?') {
      newUrl = newUrl.slice(0, length - 1);
    }
    window.history.replaceState({}, document.title, newUrl);
  }, []);
  const maintenance = import.meta.env.VITE_APP_MAINTENANCE_MODE === 'true';

  return (
    <div>
      <div>{maintenance ? <Maintenance /> : <Routers />}</div>
    </div>
  );
};

export default App;
